const Europe = [
  {
    id: 1,
    continent: 'europe',
    img: require("../Images/Europe/Venice.jpg"),
    title: "Venice",
    quote:
      "It is the city of mirrors, the city of mirages, at once solid and liquid, at once air and stone.",
    autor: "Erica Jong",
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "10/02/2036",
    dailyTripDate2: "10/08/2036",
    dailyTripDate3: "10/10/2036",
    dailyPriceAdult: 199.99,
    dailyPriceChildren: 99.99,
    weekTrip: true,
    weekTripDate1: "18/02/2036 - 25/02/2036",
    // weekEnding1: '25/02/2036',
    weekTripDate2: "18/08/2036 - 25/08/2036",
    // weekEnding2: '25/08/2036',
    weekTripDate3: "18/10/2036 - 25/10/2036",
    // weekEnding3: '25/10/2036',
    weekPriceAdult: 499.99,
    weekPriceChildren: 299.99,
    monthTrip: false,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/europe/venice",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam congue luctus vestibulum. Proin posuere magna nec leo tincidunt, eget interdum enim consectetur. Maecenas vehicula mattis nunc sed pharetra. Donec auctor, ex sit amet egestas sollicitudin, ipsum tortor porttitor odio, eu commodo odio diam laoreet ex. Vestibulum suscipit nisi non convallis molestie. Etiam et sapien felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer elit massa, vestibulum quis faucibus vel, euismod sed quam. Mauris ultricies, urna sit amet bibendum sollicitudin, nisi mi faucibus nibh, ac auctor tortor lacus in ex. Donec sed massa sodales, gravida urna eget, vestibulum elit.",
    description2:
      "Fusce placerat, felis vel semper sagittis, velit justo accumsan turpis, suscipit vestibulum purus ligula sit amet massa. Suspendisse sollicitudin porttitor porttitor. Vestibulum lacus elit, molestie sed neque ut, eleifend maximus mi. Suspendisse eget massa ac neque pulvinar varius eget vitae lectus. Duis non consectetur ex, sed scelerisque neque. Cras nec nibh rutrum, ultrices dui ut, faucibus orci. Maecenas venenatis urna vitae sapien convallis, in dignissim odio interdum. Pellentesque mi nisi, vehicula eu nibh sed, posuere vestibulum felis.",
    description3:
      "In feugiat risus id risus vulputate, eu pellentesque ipsum laoreet. Integer augue massa, condimentum laoreet vulputate vel, laoreet et elit. Ut rutrum ex velit. Mauris eu mauris egestas urna rhoncus viverra cursus eu eros. Donec sit amet sem lobortis, ornare tellus at, pharetra erat. Donec a dignissim nulla, aliquam semper nulla. Nam euismod porttitor elit, interdum hendrerit velit tempor eget.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 99,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 59,
    hotelOption2: 109,
    hotelOption3: 159,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 99,
    tripDescription1: 'Donec a dignissim nulla, aliquam semper nulla. Nam euismod porttitor elit, interdum hendrerit velit tempor eget.',
    choosenTripOption: 0,
    totalWithOptions: 0
    
  },
  {
    id: 2,
    continent: 'europe',
    img: require("../Images/Europe/Rome.jpg"),
    title: "Rome",
    quote: "A fool is one who admires other cities without visiting Rome.",
    autor: "Francesco Petrarca",
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "22/03/2026",
    dailyTripDate2: "22/05/2026",
    dailyTripDate3: "22/12/2026",
    dailyPriceAdult: 299.99,
    dailyPriceChildren: 159.99,
    weekTrip: false,
    weekTripDate1: "18/02/2036 - 25/02/2036",
    weekTripDate2: "18/08/2036 - 25/08/2036",
    weekTripDate3: "18/10/2036 - 25/10/2036",
    weekPriceAdult: 499.99,
    weekPriceChildren: 299.99,
    monthTrip: true,
    monthTripDate1: "12/02/2036 - 12/03/2036",
    monthTripDate2: "12/08/2036 - 12/09/2036",
    monthTripDate3: "12/10/2036 - 12/11/2036",
    monthPriceAdult: 1499.99,
    monthPriceChildren: 1099.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/europe/rome",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque sed auctor lorem. Aliquam tincidunt pellentesque dolor aliquam ornare. Quisque tincidunt ipsum ut mi sagittis, et accumsan dolor sodales. Nam rutrum urna ac erat luctus, eget porta lorem tincidunt. In hac habitasse platea dictumst. Aenean tempor cursus blandit. Mauris augue enim, fringilla vel facilisis sit amet, dignissim nec libero. Fusce nec tristique sapien. Nam nec fermentum nisi. Sed leo lectus, ultricies ac laoreet sed, condimentum eu neque. Curabitur bibendum eu nulla a tristique. Aenean porta in nisi ut auctor.",
    description2:
      "Phasellus placerat convallis dolor nec ultricies. Integer hendrerit sem eget iaculis tincidunt. Mauris fringilla tortor non metus lobortis, vestibulum volutpat augue fringilla. Phasellus eget condimentum ante, pharetra interdum libero. Mauris venenatis orci vel nisi tempus tincidunt. Nulla vestibulum turpis in finibus interdum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Curabitur fermentum lectus mauris, ac dapibus diam sollicitudin tristique. Donec at pharetra purus. Cras aliquam nibh metus, non pretium ipsum ultricies a. Nunc tempus tempus sem. Curabitur sed libero ante.",
    description3:
      "Phasellus purus justo, lacinia in ipsum sit amet, lobortis luctus quam. Aenean eget interdum purus, sed pharetra leo. Morbi vestibulum diam et rhoncus aliquam. Nulla facilisi. Ut a justo in enim luctus lacinia. Proin sed nibh sed diam ultrices sollicitudin. Nam nec est eu velit cursus fermentum. Mauris laoreet purus velit, et hendrerit dolor fringilla ut. Phasellus ut felis quam. Aenean lacinia libero sit amet massa venenatis scelerisque. Phasellus tincidunt lectus non suscipit feugiat. Nulla id facilisis orci. Cras finibus luctus turpis id pulvinar. Curabitur tristique odio id augue lobortis egestas. Sed efficitur lectus aliquam, lacinia enim id, facilisis erat.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 49,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 39,
    hotelOption2: 89,
    hotelOption3: 129,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 49,
    tripDescription1: 'Donec a dignissim nulla, aliquam semper nulla. Nam euismod porttitor elit, interdum hendrerit velit tempor eget.',
    tripOption2: 89,
    tripDescription2: 'Phasellus tincidunt lectus non suscipit feugiat. Nulla id facilisis orci. Cras finibus luctus turpis id pulvinar.',
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 3,
    continent: 'europe',
    img: require("../Images/Europe/Warsaw Skitterphoto.jpg"),
    title: "Warsaw",
    quote:
      "A phoenix arisen from the ashes, Poland's capital impresses with its resilience, respect for history, contemporary style and sheer joie de vivre.",
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "20/03/2036",
    dailyTripDate2: "20/05/2036",
    dailyTripDate3: "20/08/2036",
    dailyPriceAdult: 99.99,
    dailyPriceChildren: 59.99,
    weekTrip: true,
    weekTripDate1: "10/04/2036 - 17/04/2036",
    weekTripDate2: "10/07/2036 - 17/07/2036",
    weekTripDate3: "10/11/2036 - 17/11/2036",
    weekPriceAdult: 399.99,
    weekPriceChildren: 299.99,
    monthTrip: true,
    monthTripDate1: "21/02/2036 - 21/03/2036",
    monthTripDate2: "21/05/2036 - 21/06/2036",
    monthTripDate3: "21/08/2036 - 21/09/2036",
    monthPriceAdult: 1099.99,
    monthPriceChildren: 799.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/europe/warsaw",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed luctus egestas nulla in cursus. Aliquam ac pellentesque lectus. Sed nec nisi eget tellus consectetur pulvinar vitae id enim. Nunc quis pharetra odio. Nunc id dui eu felis suscipit sollicitudin eget et turpis. Nunc bibendum pretium mauris non lacinia. Etiam quis dui rutrum, pretium mi non, cursus arcu. Nunc lacinia nec leo vel eleifend. Vivamus ut lacus ut nunc cursus faucibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nunc in orci quis orci lacinia fringilla. Mauris gravida imperdiet velit, at vulputate felis rhoncus a. Aliquam in ligula at ex luctus placerat. Proin ac orci leo.",
    description2:
      "Donec pharetra diam eget quam posuere, in porttitor massa commodo. Donec faucibus ante sed volutpat finibus. Mauris laoreet ultrices diam, vel imperdiet erat faucibus in. Fusce laoreet facilisis consectetur. Sed ex leo, ornare ac vestibulum et, varius ornare diam. Cras ut turpis porttitor, cursus magna vitae, accumsan enim. Nunc nec mauris malesuada, tristique leo eget, tempor dui. Nam pretium, elit gravida auctor venenatis, eros leo sodales risus, ut eleifend metus odio mollis sem. Nullam condimentum purus et suscipit rhoncus. Maecenas vitae interdum mauris. Suspendisse ac efficitur velit, vitae fermentum turpis. Nam consequat at velit gravida elementum. Nullam vitae sagittis est. Integer non velit ut enim tincidunt lacinia. Aliquam erat volutpat. Aliquam dui justo, sodales ac mi nec, semper ultrices justo.",
    description3:
      "Vivamus ullamcorper, sapien at sollicitudin cursus, turpis ante sagittis diam, vel egestas nibh sem sed enim. Fusce quis pretium orci. Pellentesque volutpat pellentesque felis, non tincidunt quam rutrum a. Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur. Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Quisque tristique rutrum sem, ac mollis diam accumsan id. Suspendisse in nunc eget odio viverra porta. Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien. Sed maximus tellus efficitur fringilla varius. Integer lorem urna, tincidunt nec est at, tempus volutpat dolor.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 79,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 39,
    hotelOption2: 89,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 49,
    tripDescription1: 'Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.',
    tripOption2: 89,
    tripDescription2: 'Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae',
    tripOption3: 129,
    tripDescription3: 'Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.',
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 4,
    continent: 'europe',
    img: require("../Images/Europe/Paris Thorsten technoman.jpg"),
    title: "Paris",
    quote:
      "A walk about Paris will provide lessons in history, beauty, and in the point of Life..",
    autor: "Thomas Jefferson",
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: false,
    dailyTripDate1: "10/02/2036",
    dailyTripDate2: "10/08/2036",
    dailyTripDate3: "10/10/2036",
    dailyPriceAdult: 199.99,
    dailyPriceChildren: 99.99,
    weekTrip: true,
    weekTripDate1: "05/02/2036 - 12/02/2036",
    weekTripDate2: "05/08/2036 - 12/08/2036",
    weekTripDate3: "05/10/2036 - 12/10/2036",
    weekPriceAdult: 499.99,
    weekPriceChildren: 299.99,
    monthTrip: true,
    monthTripDate1: "30/03/2036 - 30/04/2036",
    monthTripDate2: "30/06/2036 - 30/07/2036",
    monthTripDate3: "30/09/2036 - 30/10/2036",
    monthPriceAdult: 1099.99,
    monthPriceChildren: 799.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/europe/paris",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec luctus justo et lorem rhoncus iaculis. Vivamus lacus eros, porttitor non lacus id, tincidunt sollicitudin elit. Mauris molestie volutpat orci, nec lacinia arcu sollicitudin ut. Integer malesuada, tellus at imperdiet tristique, nisi erat tincidunt odio, quis consequat mi ipsum et sem. Cras vitae fringilla ligula. Nunc eu efficitur dui, et tempus diam. Curabitur cursus ligula ut est blandit semper. Quisque vel tortor orci.",
    description2:
      "Ut ultricies, elit vestibulum scelerisque ultricies, risus felis lobortis ante, sit amet pharetra felis neque rutrum ante. Ut eros nisl, porttitor ac bibendum et, rhoncus eget sem. Integer scelerisque, urna at sodales sollicitudin, tortor metus viverra ante, semper mollis massa quam ac nisi. Ut sollicitudin justo vel lacus posuere, vel egestas elit congue. Maecenas eu consectetur sem. Nulla elementum est sit amet magna ultricies pharetra. Vestibulum tristique volutpat tristique. Proin sit amet accumsan dui. Duis vitae consectetur metus. Nulla facilisi. In eu pellentesque augue, sit amet luctus odio. Nullam efficitur nulla a risus scelerisque congue. Fusce tempor venenatis finibus. Morbi lorem risus, luctus at egestas sed, interdum sed est.",
    description3:
      "Donec vel semper purus. Ut in turpis eu dui ullamcorper semper. Morbi porttitor nunc ac metus faucibus, hendrerit scelerisque purus tristique. Donec sit amet ullamcorper ante. Etiam tempor justo porta commodo efficitur. Nullam hendrerit quam in ultrices tincidunt. Nam ac consectetur mi.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 39,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 59,
    choosenHotel: 0,
    tripStandard: 'Unavaiable',
    tripOption1: 49,
    tripDescription1: 'Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.',
    tripOption2: 89,
    tripDescription2: 'Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae',
    tripOption3: 129,
    tripDescription3: 'Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.',
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 5,
    continent: 'europe',
    img: require("../Images/Europe/Moscow.jpg"),
    title: "Moscow",
    quote:
      "During any season, at any hour of the day, Moscow thrills visitors with its artistry, history and majesty.",
    autor: null,
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "28/03/2036",
    dailyTripDate2: "28/05/2036",
    dailyTripDate3: "28/11/2036",
    dailyPriceAdult: 299.99,
    dailyPriceChildren: 199.99,
    weekTrip: false,
    weekTripDate1: "18/02/2036 - 25/02/2036",
    weekTripDate2: "18/08/2036 - 25/08/2036",
    weekTripDate3: "18/10/2036 - 25/10/2036",
    weekPriceAdult: 499.99,
    weekPriceChildren: 299.99,
    monthTrip: false,
    monthTripDate1: "30/03/2036 - 30/04/2036",
    monthTripDate2: "30/06/2036 - 30/07/2036",
    monthTripDate3: "30/09/2036 - 30/10/2036",
    monthPriceAdult: 1099.99,
    monthPriceChildren: 799.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/europe/moscow",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque libero libero, efficitur vitae turpis at, efficitur tincidunt diam. Maecenas porta efficitur nibh eget viverra. Donec nec consequat felis, quis viverra metus. Vestibulum non elementum ligula, id finibus augue. Curabitur non neque ac libero interdum euismod quis ut risus. Cras eget tellus sed erat porta faucibus. Ut eget dapibus elit.",
    description2:
      "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Quisque pellentesque sem massa, non efficitur nulla varius ut. Phasellus id risus placerat, laoreet dui at, elementum arcu. Ut ac elementum risus. Mauris eget libero ipsum. Pellentesque ut ultricies lacus. Fusce tempor ante ut enim dapibus, in consequat sapien dignissim. Aliquam scelerisque libero eu leo auctor venenatis. Cras orci nulla, congue eu nisl quis, egestas suscipit velit. Aenean pulvinar sodales nulla et feugiat. Aenean iaculis sollicitudin turpis, a dignissim metus interdum maximus. Duis et nulla dui. Curabitur auctor egestas bibendum.",
    description3:
      "Nulla facilisi. Morbi eget lacinia tellus. Fusce pretium dolor quis pretium ultrices. Pellentesque sodales sem massa, vitae mollis ex eleifend vitae. Aenean id nisl in nunc accumsan tincidunt. Praesent a vestibulum ligula, sit amet auctor mi. Donec tincidunt non arcu at aliquet. Aliquam sagittis gravida ultrices. Maecenas dapibus convallis lobortis. Phasellus lobortis enim vel ante rutrum, eu consectetur justo mattis. Donec vehicula nec libero sed aliquam. Ut at nibh non diam laoreet aliquam. Vivamus elit neque, iaculis quis ligula et, commodo semper eros. Aliquam pretium lorem risus, ut semper nibh faucibus et. Ut in tincidunt lacus, at ultrices turpis.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 129,
    choosenPickUp: 0,
    hotelStandard: 'Unavaiable',
    hotelOption1: 39,
    hotelOption2: 89,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 79,
    tripDescription1: 'Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.',
    tripOption2: 129,
    tripDescription2: 'Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae',
    tripOption3: 149,
    tripDescription3: 'Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.',
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 6,
    continent: 'europe',
    img: require("../Images/Europe/London.jpg"),
    title: "London",
    quote: "A bad day in London is still better than a good day anywhere else.",
    autor: null,
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "12/04/2036",
    dailyTripDate2: "12/05/2036",
    dailyTripDate3: "12/06/2036",
    dailyPriceAdult: 169.99,
    dailyPriceChildren: 69.99,
    weekTrip: true,
    weekTripDate1: "13/04/2036 - 20/04/2036",
    weekTripDate2: "13/05/2036 - 20/05/2036",
    weekTripDate3: "13/06/2036 - 20/06/2036",
    weekPriceAdult: 399.99,
    weekPriceChildren: 169.99,
    monthTrip: false,
    monthTripDate1: "30/03/2036 - 30/04/2036",
    monthTripDate2: "30/06/2036 - 30/07/2036",
    monthTripDate3: "30/09/2036 - 30/10/2036",
    monthPriceAdult: 1099.99,
    monthPriceChildren: 799.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/europe/london",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer hendrerit mattis rhoncus. In eu nunc malesuada, consequat sem a, semper diam. Vestibulum mollis sagittis diam. Aliquam hendrerit tellus sit amet ante rhoncus, blandit mollis lectus sagittis. Aliquam dignissim blandit nisi id laoreet. Phasellus tempus elementum lacinia. Quisque ullamcorper ultricies tortor sit amet scelerisque. Etiam eu magna elementum, euismod tortor nec, efficitur turpis. Mauris consectetur magna suscipit, mattis leo et, bibendum lorem. Integer pretium eu enim nec hendrerit.",
    description2:
      "Nulla sit amet ultrices nunc. Proin sed accumsan risus. Ut tristique lorem ut nunc tempus fermentum. Fusce eu ex sed ligula placerat dapibus. Mauris quis felis porttitor dolor rutrum vehicula ac eu est. Aenean placerat erat vel elementum condimentum. Aliquam pulvinar nisl tellus. Donec ac scelerisque mauris.",
    description3:
      "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis volutpat tincidunt nisi, ut porttitor orci ultricies vel. Sed venenatis suscipit vulputate. Pellentesque lacus leo, bibendum eu nisi varius, varius porttitor erat. Praesent scelerisque tempor efficitur. Proin ut condimentum nisi, ac facilisis dolor. Phasellus at felis tempus, volutpat lacus a, aliquet risus. Curabitur eu feugiat lectus. Aliquam cursus dolor mollis nisi commodo, id malesuada mi condimentum. Vivamus id metus vitae ante consequat venenatis.",
    inCart: false,
    standardPickUp: 'Unavaiable',
    pickUp: 129,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 100,
    hotelOption2: 149,
    hotelOption3: 169,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 79,
    tripDescription1: 'Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.',
    choosenTripOption: 0,
    totalWithOptions: 0
  }
];

export default Europe;
